<template>
	<div class="sell-skin _modal">
		<div class="_modal-overlay" @click.self="closeSellSkinModal"></div>
		<div class="sell-skin__inner _modal-inner">
			<div class="_modal-close" @click="closeSellSkinModal"></div>
			<div class="sell-skin__content">
				<div class="sell-skin__title _md">{{ $t('Sell your skin') }}</div>
				<Form
					v-slot="{ meta }"
					ref="form"
					@submit="onSubmit"
					class="sell-skin__form"
				>
					<!--<div class="sell-skin__desc">
						<div class="sell-skin__desc-title">
							{{ $t('Check my trade link') }}:
						</div>
						<a
							class="sell-skin__desc-link"
							target="_blank"
							href="https://steamcommunity.com/profiles/76561198080854701/tradeoffers/privacy"
						>
							https://steamcommunity.com/profiles/76561198080854701/tradeoffers/privacy
						</a>
					</div>-->
					<!-- Skin name field -->
					<Field
						name="skin_name"
						rules="required"
						v-slot="{ field, errors }"
					>
						<div class="sell-skin__label">{{ $t('Skin name') }}:</div>
						<input
							v-bind="field"
							type="text"
							required
							class="sell-skin__input"
						/>
						<div v-if="errors.length" class="sell-skin__error">
							{{ errors[0] }}
						</div>
					</Field>
					<Field
						name="quality"
						rules="required"
						v-slot="{ field, errors }"
					>
						<div class="sell-skin__label">{{ $t('Quality') }}:</div>
						<input
							v-bind="field"
							type="text"
							required
							class="sell-skin__input"
						/>
						<div v-if="errors.length" class="sell-skin__error">
							{{ errors[0] }}
						</div>
					</Field>
					<!-- Price field with manual input filtering -->
					<Field
						name="price"
						rules="required|decimal:2|min_value:0.1"
						v-slot="{ errors }"
					>
						<div class="sell-skin__label">{{ $t('Desired price') }}:</div>
						<div class="sell-skin__price">
							<input
								type="text"
								:value="priceInput"
								@input="onPriceInput"
								@blur="onPriceBlur"
								required
								class="sell-skin__input"
							/>
							<span class="sell-skin__price-currency">{{
								currencySymbol
							}}</span>
						</div>
						<div v-if="errors.length" class="sell-skin__error">
							{{ errors[0] }}
						</div>
					</Field>
					<Field
						name="steam_link"
						:rules="{
							regex: new RegExp(
								'^https:\\/\\/[a-zA-Z0-9\\-\\.]+(\\.[a-zA-Z]{2,})(:[0-9]{1,5})?(\\/.*)?$'
							),
						}"
						v-slot="{ field, errors }"
					>
						<div class="sell-skin__label">
							{{ $t('Steam trade link') }}:
						</div>
						<input
							v-bind="field"
							type="text"
							required
							class="sell-skin__input"
						/>
						<div v-if="errors.length" class="sell-skin__error">
							{{ errors[0] }}
						</div>
					</Field>
					<transition name="slide">
						<div v-if="error" class="sell-skin__error">
							{{ $t(error) }}
						</div>
					</transition>
					<transition name="slide">
						<div v-if="success" class="sell-skin__success">
							{{ $t(success) }}
						</div>
					</transition>
					<BaseButton
						type="submit"
						:disabled="!meta.touched || !meta.valid || isSubmitting"
						class="sell-skin__submit _btn-primary"
					>
						{{ $t('Submit') }}
					</BaseButton>
				</Form>
			</div>
		</div>
	</div>
</template>

<script>
import axios from '@/axios';
import { Field, Form } from 'vee-validate';
import BaseButton from './base/BaseButton.vue';

export default {
	name: 'SellSkinModal',
	props: {
		currencySymbol: {
			type: String,
			default: '€',
		},
	},
	components: {
		Form,
		Field,
		BaseButton,
	},
	data() {
		return {
			isSubmitting: false,
			priceInput: '',
			success: '',
			error: '',
		};
	},
	mounted() {
		this.isSubmitting = false;
	},
	methods: {
		closeSellSkinModal() {
			console.log('click');
			this.$emit('closeSellSkinModal');
		},

		onPriceInput(event) {
			let value = event.target.value;

			// Удаляем все кроме цифр и точки
			value = value.replace(/[^0-9.]/g, '');

			// Оставляем только одну точку
			const parts = value.split('.');
			if (parts.length > 2) {
				value = parts[0] + '.' + parts[1];
			}

			// Ограничиваем до 2 знаков после точки
			if (parts[1]) {
				parts[1] = parts[1].slice(0, 2);
				value = parts[0] + '.' + parts[1];
			}

			// Если начинается с точки, добавляем 0 перед ней
			if (value.startsWith('.')) {
				value = '0' + value;
			}

			this.priceInput = value;

			// Обновим значение поля vee-validate вручную
			this.$refs.form.setFieldValue('price', value);
		},

		onPriceBlur() {
			// Дополнительно — убираем точку на конце при потере фокуса
			if (this.priceInput.endsWith('.')) {
				this.priceInput = this.priceInput.slice(0, -1);
				this.$refs.form.setFieldValue('price', this.priceInput);
			}
		},

		async onSubmit(values) {
			this.isSubmitting = true;
			try {
				await axios.post('offer/create', {
					item_url: values.steam_link,
					title: values.skin_name,
					price: parseFloat(this.priceInput),
					quality: values.quality,
				});

				this.error = '';
				this.success = 'Success';
				this.$emit('offerCreated');
				setTimeout(() => {
					this.closeSellSkinModal();
					this.isSubmitting = false;
				}, 3000);
			} 
			catch (error) {
				console.log('error', error);
				
				const responseData = error.response?.data;
				
				if (responseData?.errors) {
					const firstField = Object.keys(responseData.errors)[0];
					this.error = responseData.errors[firstField][0];
				} else if (responseData?.message) {
					this.error = responseData.message;
				}
				
				this.isSubmitting = false;
			}
		},
	},
};
</script>

<style lang="scss" scoped>
@use '@/assets/styles/mixins' as *;
@use '@/assets/styles/media' as *;
@use '@/assets/styles/components/classes' as *;

.sell-skin {
	&__inner {
		max-width: 500px;
		margin: 0 auto;
	}
	&__content {
		max-width: 350px;
		margin: 0 auto;
	}
	&__title {
		text-transform: uppercase;
		text-align: center;
		&:not(:last-child) {
			@include adaptiveValue('margin-bottom', 20, 15);
		}
	}
	&__form {
	}
	&__desc {
		display: flex;
		flex-direction: column;
		align-items: center;
		@include adaptiveValue('gap', 10, 6);
		&:not(:last-child) {
			margin-bottom: 15px;
		}
		&-title {
			font-weight: 400;
			text-align: center;
		}
		&-link {
			font-weight: 400;
			text-decoration: underline;
			display: inline-block;
			color: var(--seventh-color);
			max-width: 280px;
			margin: 0 auto;
			overflow: hidden;
			white-space: nowrap;
			text-overflow: ellipsis;
			@media (any-hover: hover) {
				&:hover {
					color: var(--primary-color);
				}
			}
		}
	}
	&__label {
		display: block;
		text-align: center;
		font-weight: 500;
		text-transform: capitalize;
		&:not(:last-child) {
			margin-bottom: 5px;
		}
	}
	&__input {
		width: 100%;
		height: 44px;
		border-radius: var(--border-radius-primary);
		background-color: var(--bg-secondary-color);
		border: 1px solid var(--bg-third-color);
		padding: 0px 15px;
		display: flex;
		justify-content: center;
		align-items: center;
		color: var(--primary-color);
		text-align: center;
		outline: transparent;
		transition: border 0.3s ease 0s;
		font-size: var(--font-size-base);
		resize: none;
		transition: border 0.3s ease 0s;
		&:focus {
			border: 1px solid var(--primary-color);
		}
		&:not(:last-child) {
			@include adaptiveValue('margin-bottom', 15, 10);
		}
	}
	&__price {
		position: relative;
		&-currency {
			position: absolute;
			right: 10px;
			bottom: 8px;
		}
	}
	&__success,
	&__error {
		margin-bottom: 8px;
		text-align: center;
		text-transform: capitalize;
	}
	&__error {
		color: var(--error-color);
	}
	&__success {
		color: var(--success-color);
	}
	&__submit {
		min-width: 160px;
		margin: 0 auto;
		@include adaptiveValue('margin-top', 40, 15);
	}
}
</style>
